import { extractNewAnddeclaration } from "../GuidelineNav/menuGeneration";

const items = [
  { key: "Whats_New", label: "What's new" },
  { key: "expert-groups", label: "Expert group" },
  { key: "acknowledgements", label: "Acknowledgements" },
  { key: "Declaration_of_Interest", label: "Declaration of interests" },
];

const specialCases = {
  Palliative_Care: "https://www.tg.org.au/content-updates/palliativecare",
  Rheumatology: "https://www.tg.org.au/content-updates/rheumatology",
  Toxicology_and_Toxinology:
    "https://www.tg.org.au/content-updates/toxicologyandtoxinology",
  Cardiovascular: "https://www.tg.org.au/content-updates/cardiovascular",
  Psychotropic: "https://www.tg.org.au/content-updates/psychotropic/",
  Antibiotic:
    "https://www.tg.org.au/products/therapeutic-guidelines/updates/antibiotic/",
  Oral_and_Dental:
    "https://www.tg.org.au/products/therapeutic-guidelines/updates/oral-and-dental/",
};

export const additionalResourceItems = (
  glObj,
  whatsNewLink,
  doiLink,
  ccmsversion,
) => {
  return items
    .map(({ key, label }) => {
      if (key === "acknowledgements" || key === "expert-groups") {
        return {
          key: key,
          title: label,
          msPath: `/resources/${glObj?.glPage?.replaceAll(" ", "_")}/${key}`,
        };
      }

      if (key === "Whats_New") {
        if (whatsNewLink && whatsNewLink?.startsWith("https://www.tg.org.au")) {
          return {
            key: key,
            title: label,
            msPath: whatsNewLink,
            isExternal: true,
          };
        } else {
          const slicedLink = whatsNewLink.replace("../", "");
          return {
            key: key,
            title: label,
            msPath: `https://ccmsfiles.tg.org.au/${ccmsversion?.selected}/${slicedLink}`,
            isExternal: true,
          };
        }
      }

      if (key === "Declaration_of_Interest") {
        const slicedLink = doiLink?.replace("../", "");
        return {
          key: key,
          title: label,
          msPath: `https://ccmsfiles.tg.org.au/${ccmsversion?.selected}/${slicedLink}`,
          isExternal: true,
        };
      }

      return null;
    })
    .filter(Boolean);
};

export const fetchContentForLinks = async (glObj, iDB, ccmsversion) => {
  const path =
    glObj.glPage === "Palliative_Care"
      ? "Palliative_Care/palliative_care.dita"
      : `${glObj.glPage}/${glObj.glPage}.dita`;

  try {
    const localData = await iDB.read(path);
    if (localData) {
      const link = extractNewAnddeclaration(localData);
      return {
        whatsNew: specialCases[glObj.glPage] || link.whatsNewLink || "",
        doi: link.declarationLink || "",
      };
    }

    const res = await fetch(
      `https://ccmsfiles.tg.org.au/${ccmsversion?.selected}/${path}`,
    );
    if (!res.ok) throw new Error("Failed to fetch remote DITA file");
    const raw = await res.text();
    const link = extractNewAnddeclaration(raw);
    return {
      whatsNew: specialCases[glObj.glPage] || link.whatsNewLink || "",
      doi: link.declarationLink || "",
    };
  } catch (err) {
    console.error("Error fetching DOI / What's New content:", err);
    return { whatsNew: "", doi: "" };
  }
};
